import { styled } from "styled-components";
import { rgba } from "polished";
const InPlaceInputWrapper = styled("div")({
  display: "flex"
});
const InPlaceInputTextArea = styled("textarea")(
  ({ readOnly, theme, variant }) => ({
    backgroundColor: "transparent",
    border: "none",
    borderRadius: 2,
    boxSizing: "border-box",
    color: variant === "title" ? theme.color.gray9 : theme.color.gray8,
    "-webkit-text-fill-color": variant === "title" ? theme.color.gray9 : theme.color.gray8,
    flexBasis: "auto",
    flexGrow: 1,
    flexShrink: 1,
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize[variant === "title" ? "lg" : "default"],
    fontWeight: theme.fontWeight[variant === "title" ? "medium" : "normal"],
    lineHeight: theme.lineHeight[variant === "title" ? "lg" : "default"],
    margin: 0,
    marginTop: -2,
    opacity: 1,
    outline: 0,
    overflow: "hidden",
    padding: 0,
    paddingTop: variant === "title" ? 1 : 2,
    paddingBottom: variant === "title" ? 1 : 2,
    resize: "none",
    "&::placeholder": {
      color: theme.color.gray6,
      "-webkit-text-fill-color": theme.color.gray6,
      opacity: 1
    },
    "&:focus-within": {
      boxShadow: readOnly ? void 0 : `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`
    }
  }),
  ({ height }) => ({ height })
);
const InPlaceInputButtonWrapper = styled("div")(
  {
    alignSelf: "start",
    borderRadius: 2,
    margin: "-2px 0 -2px 8px"
  },
  ({ $editMode, theme }) => $editMode ? {
    boxShadow: `0 0 0 1px ${theme.controlBorderColor}`
  } : void 0
);
export {
  InPlaceInputButtonWrapper,
  InPlaceInputTextArea,
  InPlaceInputWrapper
};
